<template>
  <img class="logo-app" src="./../../assets/logo.png" />
</template>
<script lang="ts">
import { Vue } from "vue-class-component";
export default class Logo extends Vue {}
</script>

<style lang="scss">
.logo-app {
  width: 50px;
}
</style>
